export enum AppQueryKeys {
  AppUser = 'App.AppUser',
}

export enum AttachmentQueryKeys {
  Add = 'Attachment.AddAttachmentToEventReport',
  Delete = 'Attachment.DeleteAttachment',
  Get = 'Attachment.GetAttachmentsForEventReport',
}

export enum AuditLogQueryKeys {
  Get = 'AuditLog.Logs',
}

export enum CabinEventQueryKeys {
  Approve = 'CabinEvent.Approve',
  CreateNew = 'CabinEvent.CreateNew',
  Delete = 'CabinEvent.Delete',
  ApprovalList = 'CabinEvent.GetCabinEventApprovalList',
  Drafts = 'CabinEvent.GetDrafts',
  FieldOptions = 'CabinEvent.GetFieldOptions',
  Get = 'CabinEvent.GetCabinEventReportById',
  Submissions = 'CabinEvent.GetSubmissions',
  SaveNew = 'CabinEvent.SaveNew',
  Submit = 'CabinEvent.Submit',
  Update = 'CabinEvent.Update',
}

export enum CommonQueryKeys {
  AllEventPhases = 'Common.AllEventPhases',
  AllAirports = 'Common.GetAllAirports',
}

export enum DispatchEventQueryKeys {
  Approve = 'DispatchEvent.Approve',
  CreateNew = 'DispatchEvent.CreateNew',
  CreateNewFromExisting = 'DispatchEvent.CreateNewFromExisting',
  Delete = 'DispatchEvent.Delete',
  ApprovalList = 'DispatchEvent.GetApprovalList',
  AllSubmissions = 'DispatchEvent.GetAllSubmissions',
  Drafts = 'DispatchEvent.GetDrafts',
  FieldOptions = 'DispatchEvent.GetFieldOptions',
  Get = 'DispatchEvent.GetDispatchEventReportById',
  Submissions = 'DispatchEvent.GetSubmissions',
  SaveNew = 'DispatchEvent.SaveNew',
  Submit = 'DispatchEvent.Submit',
  Update = 'DispatchEvent.Update',
}

export enum SafetyEventQueryKeys {
  CreateNew = 'SafetyEvent.CreateNew',
  Delete = 'SafetyEvent.Delete',
  AllSubmissions = 'SafetyEvent.GetAllSubmissions',
  Drafts = 'SafetyEvent.GetDrafts',
  FieldOptions = 'SafetyEvent.GetFieldOptions',
  Get = 'SafetyEvent.GetSafetyEventReportById',
  Submissions = 'SafetyEvent.GetSubmissions',
  SaveNew = 'SafetyEvent.SaveNew',
  Submit = 'SafetyEvent.Submit',
  Update = 'SafetyEvent.Update',
  ApprovalList = 'SafetyEvent.ApprovalList',
}

export enum EmployeeQueryKeys {
  Find = 'Employee.Find',
}

export enum EventReportQueryKeys {
  Unattached = 'EventReport.GetUnattachedEventReports',
  AddToIncident = 'AddToIncident',
  RemoveFromIncident = 'RemoveFromIncident',
  Filtered = 'EventReport.GetFilteredEventReports',
  GetListByType = 'EventReport.GetEventReportsList',
}

export enum FlightEventQueryKeys {
  Approve = 'FlightEvent.Approve',
  CreateNew = 'FlightEvent.CreateNew',
  Delete = 'FlightEvent.Delete',
  AllSubmittedReports = 'FlightEvent.AllSubmittedReports',
  ApprovalList = 'FlightEvent.ApprovalList',
  Drafts = 'FlightEvent.Drafts',
  FieldOptions = 'FlightEvent.FieldOptions',
  FlightEventReport = 'FlightEvent.FlightEventReport',
  Submissions = 'FlightEvent.Submissions',
  SaveNew = 'FlightEvent.SaveNew',
  Submit = 'FlightEvent.Submit',
  Update = 'FlightEvent.Update',
  ReNotify = 'FlightEvent.ReNotify',
}

export enum FlightOperationNotificationQueryKeys {
  CreateNew = 'FlightOperationNotification.CreateNew',
  Delete = 'FlightOperationNotification.Delete',
  Get = 'FlightOperationNotification.GetFlightOperationNotificationReportById',
  GetVersionGroups = 'FlightOperationNotification.GetFlightOperationNotificationVersionGroups',
  GetAtVersion = 'FlightOperationNotification.GetAtVersion',
  AllSubmissions = 'FlightOperationNotification.GetAllSubmissions',
  Drafts = 'FlightOperationNotification.GetDrafts',
  FieldOptions = 'FlightOperationNotification.GetFieldOptions',
  SaveNew = 'FlightEvent.SaveNewFlightOperationNotification',
  Submit = 'FlightOperationNotification.Submit',
  Update = 'FlightOperationNotification.Update',
}

export enum IncidentQueryKeys {
  CreateNew = 'Incident.CreateNew',
  Delete = 'Incident.Delete',
  Find = 'Incident.Find',
  AllForms = 'Incident.GetAllForms',
  Get = 'Incident.GetIncidentReportById',
  GetIncidentWorkflowStatus = 'Incident.GetStatus',
  GetIncidentEventReportsById = 'Incident.GetIncidentEventReportsById',
  GetMany = 'Incident.GetIncidents',
  CabinEventApprovals = 'Incident.GetRecentCabinEventList',
  DispatchEventApprovals = 'Incident.GetRecentDispatchEventList',
  FlightEventApprovals = 'Incident.GetRecentFlightEventList',
  Update = 'Incident.Update',
  CloseIncident = 'Incident.CloseIncident',
  UpdateStatus = 'Incident.UpdateIncidentStatus',
  SafetyEventSubmissions = 'Incident.GetRecentSafetyEventList',
  FieldOptions = 'GetIncidentFieldOptions',
}

export enum MetadataQueryKeys {
  GetAllowedFormActionsForIncident = 'Metadata.GetAllowedFormActionsForIncident',
  GetAdminAuthorizedForms = 'Metadata.GetAdminAuthorizedForms',
  AllowedActions = 'Metadata.GetAllowedActions',
  AuthorizedForms = 'Metadata.AuthorizedForms',
  FormName = 'Metadata.GetFormName',
  Metadata = 'Metadata.FormMetadata',
  UploadUserGuide = 'Metadata.UploadUserGuide',
}

export default {
  App: AppQueryKeys,
  Attachment: AttachmentQueryKeys,
  AuditLog: AuditLogQueryKeys,
  CabinEvent: CabinEventQueryKeys,
  Common: CommonQueryKeys,
  DispatchEvent: DispatchEventQueryKeys,
  SafetyEvent: SafetyEventQueryKeys,
  Employee: EmployeeQueryKeys,
  EventReport: EventReportQueryKeys,
  FlightEvent: FlightEventQueryKeys,
  FlightOperationNotification: FlightOperationNotificationQueryKeys,
  Incident: IncidentQueryKeys,
  Metadata: MetadataQueryKeys,
};
